import axios from "../../../axios";

const getPayrollList = async () => {
  try {
    const { data } = await axios.get(`/payroll`);
    return data;
  } catch (e) {
    return null;
  }
}

const addNewPayroll = async ({rates}) => {
  try {
    const { data } = await axios.post(`/payroll`, {rates});
    return data;
  } catch (e) {
    return null;
  }
}

const clockIn = async () => {
  try {
    const { data } = await axios.post(`/payroll/clock-in`, {});
    return data;
  } catch (e) {
    return null;
  }
}

const clockOut = async () => {
  try {
    const { data } = await axios.post(`/payroll/clock-out`, {});
    return data;
  } catch (e) {
    return null;
  }
}

const getTimeClockStatus = async () => {
  try {
    const { data } = await axios.get(`/payroll/time-status`);
    return data;
  } catch (e) {
    return null;
  }
}

export { getPayrollList, addNewPayroll, clockIn, clockOut, getTimeClockStatus };